import { ComponentType, FC, memo, useContext, useEffect } from "react";

import { getDefaultOrganizationRoute } from "@simplyk/common";
import { useRouter } from "next/router";

import { useCurrentUserContext } from "../../contexts/CurrentUserContext";
import { LayoutProps } from "../../layouts/type";
import { PageLoadingContext } from "../../providers/PageLoadingProvider";

import { isOrganizationRoute, redirectToLogout } from "@/helpers/auth";
import { useLogRouteChangePageVisits, RouteType } from "@/hooks/amplitude/useLogRouteChangePageVisits";

export interface DonorRouteProps extends LayoutProps {
  layout: ComponentType<LayoutProps>;
}

const DonorRouteToMemoized: FC<DonorRouteProps> = ({ children, layout: Layout, ...restOfLayoutProps }) => {
  const router = useRouter();
  useLogRouteChangePageVisits({ path: router.pathname, routeType: RouteType.DonorRoute });
  const { isAuthenticated, userIsLoading, connectedAsAdministrator, userPermissions } = useCurrentUserContext();
  const { setRedirectionLoading } = useContext(PageLoadingContext);
  if (!userIsLoading && !isAuthenticated) {
    redirectToLogout({ connectedAsAdministrator });
  }

  if (isOrganizationRoute(router.pathname)) {
    router.push(getDefaultOrganizationRoute(userPermissions));
  }

  useEffect(() => {
    setRedirectionLoading(false);
  }, [setRedirectionLoading]);

  return <Layout {...restOfLayoutProps}>{children}</Layout>;
};

export const DonorRoute = memo(DonorRouteToMemoized);
